"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicDragType = void 0;
/**
 * Used by `react-dnd`
 * @type {{WINDOW: string}}
 */
exports.MosaicDragType = {
    WINDOW: 'MosaicWindow',
};
//# sourceMappingURL=types.js.map